// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar .logo, .navbar .logo .user-avatar {\n  padding-left: 5px;\n  width: auto;\n  line-height: 44px;\n}\n.el-dropdown-menu__item--divided {\n  border-top: none !important;\n}", ""]);
// Exports
module.exports = exports;
